import { render } from "./BaseNotes.vue?vue&type=template&id=6deb6368&scoped=true"
import script from "./BaseNotes.vue?vue&type=script&lang=js"
export * from "./BaseNotes.vue?vue&type=script&lang=js"

import "./BaseNotes.vue?vue&type=style&index=0&id=6deb6368&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6deb6368"]])

export default __exports__